var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show_button)?_c('img',{staticClass:"question-btn",attrs:{"src":_vm.env.public_base + '/assets/images/question.gif'},on:{"click":function($event){return _vm.showModal()}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }